import React from "react";
import { NEFThemeProvider } from "@nef/core";

import SelfRegistrationComponent from "./app_components/SelfRegistrationComponent";

const RegistrationPage = () => {
  // eslint-disable-next-line prettier/prettier
  return (
    <>
      <NEFThemeProvider>
        <SelfRegistrationComponent />
      </NEFThemeProvider>
    </>
  );
};

export default RegistrationPage;
